import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add, Close, NotificationAdd } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import SelectMultipleCompanyEmployee from "../Quotes/QuoteForm/SelectMultipleCompanyEmployees";

const SendPickupAvailableNotificationDialog = ({
  orderId,
  open,
  handleClose,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [order, setOrder] = useState(null);
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [sendQuoteCopyTo, setSendQuoteCopyTo] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);

  // This is admin only
  const getOrder = async (orderId) => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/admin/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOrder(response.data.order);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const sendNotification = async (orderId, sendQuoteCopyTo) => {
    try {
      setLoading(true);
      const response = await ezorder.post(
        `/shop/jobs/${orderId}/pickup-history/send-notification`,
        { sendTo: sendQuoteCopyTo },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      // setOrder(response.data.order);
      handleClose();
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  // This is admin only
  const getOrderWithPickupHistory = async (orderId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/shop/jobs/${orderId}/pickup-history`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOrderDetails(res.data.order);
      // setPickupItems(res.data.order.pickupHistory.items);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(order);
    if (order && order.estimateRequestedBy) {
      setSendQuoteCopyTo([order.estimateRequestedBy]);
    }
  }, [order]);

  useEffect(() => {
    getOrder(orderId);
    getOrderWithPickupHistory(orderId);
  }, [orderId]);

  if (order && orderDetails)
    return (
      <Dialog
        fullWidth
        open={open}
        onClose={() => {
          handleClose();
        }}
      >
        <DialogTitle>Send Pickup Available Notification</DialogTitle>
        <DialogContent>
          <Box sx={{ paddingTop: "8px" }}>
            <SelectMultipleCompanyEmployee
              required
              disabled={!order.company}
              companyId={order.company ? order.company.id : null}
              value={sendQuoteCopyTo}
              onUpdate={(users) => {
                setSendQuoteCopyTo(users);
              }}
              label="Send To"
              enableAdd={true}
            />
          </Box>
          <Typography variant="h6" sx={{ marginTop: "16px" }}>
            Items
          </Typography>
          <TableContainer component={Box} sx={{ margin: 0, padding: 0 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ width: "70px" }}>
                    Type
                  </TableCell>
                  <TableCell align="left">Name</TableCell>
                  {!isSmallScreen && (
                    <TableCell align="left" sx={{ width: "120px" }}>
                      Received
                    </TableCell>
                  )}
                  <TableCell align="left" sx={{ width: "70px" }}>
                    Available
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderDetails.pickupHistory &&
                  orderDetails.pickupHistory.items &&
                  orderDetails.pickupHistory.items.map((item, index) => {
                    return (
                      <>
                        <TableRow key={item.id}>
                          <TableCell align="left">{item.objectType}</TableCell>
                          <TableCell align="left">{item.itemName}</TableCell>
                          {!isSmallScreen && (
                            <TableCell align="left">
                              <Typography>
                                {item.quantityReceived} / {item.quantity}{" "}
                                {item.uom}
                              </Typography>
                            </TableCell>
                          )}

                          <TableCell align="left">
                            {item.quantity - item.quantityReceived} {item.uom}
                          </TableCell>
                          <Divider />
                        </TableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              sendNotification(orderId, sendQuoteCopyTo);
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default SendPickupAvailableNotificationDialog;
